import _ from 'lodash';
import { dataConstants } from "services/redux/data/constants";
import ObjectClass from "utils/objects/object";
import HelperAvailability from "utils/helper/HelperAvailability";
import { bookingConstants } from "utils/constants/booking-constants";
import { roomConstants } from "utils/constants/room-constants";
import { constantsActive } from 'utils/constants/constants'

export default class ObjectRoom {
	
	static defaults = {
		kind: roomConstants.KIND_ROOM,
		available_for: HelperAvailability.AVAILABLE_FOR_EVERYONE,
		aed: constantsActive.NO,
		active: constantsActive.YES,
	}
	
	static get = ( objects ) => {
		return ObjectClass.get( objects, dataConstants.ROOMS );
	}
	
	static filter = ( objects ) => {
		return _.filter( ObjectClass.filterActive( objects ), object => {
			return HelperAvailability.isAvailable( bookingConstants.ROOM, object );
		})
	}
	
	static filterKind = ( objects, kind = roomConstants.KIND_ROOM ) => {
		return _.filter( objects, o => {
			return o?.kind === kind;
		})
	}
	
	/**
	 * Sort teh bookings by start
	 * @param objects
	 * @returns {objects[]}
	 */
	static order = ( objects ) => {
		return _.orderBy( objects, 'position', 'asc' )
	}
	
	/**
	 * Remove inactive bookings and sort by start
	 * @param objects
	 * @param kind
	 * @returns {objects[]}
	 */
	static filterAndOrder = ( objects ) => {
		return this.order(
			this.filter( objects )
		);
	}
}
